import { Fragment, lazy, Suspense } from "react";
import { Helmet } from "react-helmet";
import Menu from "../menu/Menu";
import InfoSuenios from "../home/InfoSuenios";
const Footer = lazy(() => import('../footer/Footer'));
function Suenios() {
  return (
    <Fragment>
      <Helmet>
        <meta
          name="description"
          content="Hace 70 años, un hombre cumplió su sueño: que mejor era posible. Chung Ju-Yung vio, sintió y vivió los problemas de su país."
        />
        <meta name="keywords" content="Hyyundai, Chung Ju-Yung, Sueño" />
        <title>Hyundai Creciendo un sueño</title>
      </Helmet>
      <Menu />
      <InfoSuenios />
      <Suspense fallback={<div>Cargando footer...</div>}>
        <Footer />
      </Suspense>
    </Fragment>
  );
}
export default Suenios;